import React, {Component} from "react";
import {
    Grid,
    Typography
} from "@mui/material";
import axios from "axios";
import {Table} from "./components";

class Statistics extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            count: 0,
            currentPage: 1,
            totalPages: 1,
            loading: true,
            sortOrder: "DESC",
            filter: {
                perPage: 20
            }
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.sortOrder !== this.state.sortOrder) {
            this.fetchData();
        }

        if (prevState.currentPage !== this.state.currentPage) {
            this.fetchData();
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    toggleSort = () => {
        this.setState((prev) => ({
            sortOrder: prev.sortOrder === "ASC" ? "DESC" : "ASC",
        }));
    };

    fetchData = () => {
        this.setState({ loading: true });

        axios.get(`${process.env.REACT_APP_SMART_SEARCH_API}/api/v1/statistics`, {
            auth: {
                username: 'md',
                password: 'Q&!7NGW0ozdp5_16',
            },
            params: {
                sort: this.state.sortOrder, // <-- передаем сортировку
                page: this.state.currentPage,
                perPage: this.state.filter.perPage
            }
        }).then((data) => {
            this.setState({
                count: data.data.count,
                items: data.data.items,
                totalPages: Math.ceil(data.data.count / 20),
            });
        }).catch((error) => {
            console.error(error);
            alert("Произошла ошибка");
        }).finally(() => {
            this.setState({ loading: false });
        });
    }

    onChangePage = (page) => {
        this.setState({ currentPage: page });
    }

    render() {
        const { items, count, loading, sortOrder, currentPage, totalPages } = this.state;
        return (
            <>
                <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                    <Grid item>
                        <Typography variant="h1">Статистика</Typography>
                        <Typography variant="h3">Всего запросов: {count}</Typography>
                    </Grid>
                </Grid>

                <Table
                    data={items}
                    isLoad={loading}
                    onToggleSort={this.toggleSort}
                    sortOrder={sortOrder}
                    totalPage={totalPages}
                    currentPage={currentPage}
                    onChangePage={this.onChangePage}
                />
            </>
        );
    }
}

export default Statistics
